function heroBannerSlider() {
  var heroBadge = document.querySelector('.hero__badge .swiper-container');
  if (!heroBadge) {
    return;
  }

  var swiper = new Swiper(heroBadge, {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.hero__badge .swiper-button-next',
      prevEl: '.hero__badge .swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  heroBannerSlider();
});
